import React, { useEffect, useState } from 'react'
import { Modal, Select, notification, Button, Input } from 'antd'
import { getSingleCompanyEmailNew } from '../../containers/onlineSubmission/actions'
import { useDispatch } from 'react-redux'
import { InputBox } from './appUtils'

let { Option } = Select
const { confirm } = Modal

// let emails = ['contact@arcc.com', 'poonam@arcc.com']


const ChooseEmailMainComponent = (props) => {
  let { title } = props
  let [emails, setEmails] = useState([])
  let [email, setEmail] = useState('')
  let [searchText, setSearchText] = useState('')

  useEffect(() => {
    loadEmails()
  }, [])

  const loadEmails = async () => {
    let { data } = await getSingleCompanyEmailNew()
    if (data && data.mailers) {
      setEmails(data.mailers)
    }
  }

  const submitFxn = () => {
    const finalEmail = email || searchText
    if (!finalEmail) {
      notification.error({ message: 'Select or Type From Email' })
      return
    }
    props.onSubmit(finalEmail)
  }

  return (
    <div>
      <InputBox title={title ? 'Select From Email' : ''}>
        {emails && emails.length ? (
          <Select
            showSearch
            style={{ width: '100%' }}
            onSearch={(val) => setSearchText(val)}
            onChange={(e) => {
              setEmail(e)
              setSearchText(e)
            }}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {emails.map((item, key) => (
              <Option key={key} value={item.userName}>{item.userName}</Option>
            ))}
          </Select>
        ) : (
          <Input
            placeholder="Type From Email address"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
          />
        )}
      </InputBox>
      <div className={'alignRight'}>
        <Button onClick={() => props.onCancel()}>
          Cancel
        </Button> {'  '}
        <Button onClick={() => submitFxn()} type={'primary'}>
          Done
        </Button>
      </div>
    </div>
  )
}


const chooseEmailModalFxn = (props) => {
  let { title = null } = props
  let modalData = (
    Modal.info({
      title: title ? title : 'Select From Email',
      className: 'chooseEmailModal',
      content: (
        <ChooseEmailMainComponent
          title={title}
          onCancel={() => {
            modalData.destroy()
            if (props.cancel) {
              props.cancel()
            }
          }}
          onSubmit={(email) => {
            modalData.destroy()
            props.callback(email)
          }}/>
      ),
      icon: false,
      okText: 'Yes',
      cancelText: 'No',
      onOk() {

      }
    })
  )

  return (
    modalData
  )
}

export default chooseEmailModalFxn
